<template>
  <v-dialog
    v-if="expenseData"
    v-model="store.viewDialog"
    :fullscreen="$vuetify.breakpoint.mdAndDown"
    width="960"
    scrollable
    overlay-opacity="0.6"
  >
    <v-card
      :class="{
        'scrollable-card': !isScroll,
        'scrollable-text-card': !isScroll && $vuetify.breakpoint.mdAndDown,
        'scrollable-not-card': !isScroll && arrivedState.bottom,
      }"
    >
      <v-card-title class="grey">
        <div class="d-flex align-center justify-space-between" style="width: 100%">
          <div class="d-flex align-center">
            <v-icon color="white" size="48">
              {{ icons.mdiAbacus }}
            </v-icon>

            <div class="text-h5 font-weight-bold ms-3 white--text">Masraf Detayı</div>
          </div>
          <v-btn color="grey" depressed fab @click="closeForm()">
            <v-icon large>
              {{ icons.mdiCloseCircle }}
            </v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-divider />

      <v-card-text class="pa-0" ref="scrollableEl" style="height: 100svh">
        <v-list color="grey" dense>
          <v-list-item>
            <v-list-item-title class="ps-2">Masraf Başlığı</v-list-item-title>
            <v-list-item-subtitle class="white--text">
              {{ expenseData.stext }}
            </v-list-item-subtitle>
          </v-list-item>
          <v-divider />
          <v-list-item>
            <v-list-item-title class="ps-2">Şube</v-list-item-title>
            <v-list-item-subtitle
              class="white--text py-2"
              style="text-wrap: initial; line-height: 1.25"
              >{{ expenseData.name1 }}</v-list-item-subtitle
            >
          </v-list-item>
          <v-divider />
          <v-list-item>
            <v-list-item-title class="ps-2">Talep Eden</v-list-item-title>
            <v-list-item-subtitle class="py-2">
              <div class="white--text">{{ expenseData.pers_display_name }}</div>
              <div class="text-overline" style="line-height: 1.5">{{ expenseData.persid }}</div>
            </v-list-item-subtitle>
          </v-list-item>
          <v-divider />

          <v-list-item>
            <v-list-item-title class="ps-2">Durum</v-list-item-title>
            <v-list-item-subtitle>
              <v-chip :color="expenseData.statustype || 'error'" text label small>
                <div class="text-center text-uppercase text-caption">
                  {{ expenseData.status_txt || "BELİRSİZ" }}
                </div>
              </v-chip>
            </v-list-item-subtitle>
          </v-list-item>
          <v-divider />
          <v-list-item>
            <v-list-item-title class="ps-2">Toplam Tutar</v-list-item-title>
            <v-list-item-subtitle class="white--text">
              {{ expenseData.genamount | currency({ symbol: "" }) }} {{ expenseData.currency }}
            </v-list-item-subtitle>
          </v-list-item>
          <v-divider />
          <v-list-item>
            <v-list-item-title class="ps-2">Kayıt Tarihi</v-list-item-title>
            <v-list-item-subtitle class="white--text">
              {{ expenseData.created_date }}
            </v-list-item-subtitle>
          </v-list-item>
        </v-list>
        <v-data-table :headers="headers" :items="items" :items-per-page="-1" hide-default-footer>
          <template #[`item.image`]="{ item }">
            <v-card
              class="d-flex align-center justify-center my-2"
              style="cursor: pointer"
              color="grey"
              flat
              min-width="55"
              min-height="55"
            >
              <v-img
                v-if="item.image"
                :src="item.image"
                width="55"
                height="55"
                cover
                @click="openImageDialog(item.image)"
              />
              <v-icon v-else color="white" size="32">
                {{ icons.mdiImageOffOutline }}
              </v-icon>
            </v-card>

            <!-- Resim Büyütme Dialog -->
            <v-dialog v-model="imagePreviewDialog" max-width="800px">
              <v-card>
                <v-card-title class="grey">
                  <div class="d-flex justify-space-between align-center" style="width: 100%">
                    <span class="white--text">Önizleme</span>
                    <v-btn icon @click="imagePreviewDialog = false">
                      <v-icon color="white">{{ icons.mdiCloseCircle }}</v-icon>
                    </v-btn>
                  </div>
                </v-card-title>
                <v-card-text class="pa-0">
                  <v-img :src="selectedImage" max-height="600" contain />
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>
          <template #[`item.expense_type`]="{ item }">
            {{ item.expense_type }}
          </template>
          <template #[`item.receipt_date`]="{ item }">
            {{ item.receipt_date }}
          </template>
          <template #[`item.receipt_no`]="{ item }">
            {{ item.receipt_no }}
          </template>
          <template #[`item.amount`]="{ item }">
            <div class="white--text">
              {{ item.amount | currency({ symbol: "" }) }} {{ item.currency }}
            </div>
          </template>

          <template #[`item.ltext`]="{ item }">
            {{ item.ltext }}
          </template>
        </v-data-table>
      </v-card-text>

      <v-card-actions class="d-flex flex-column-reverse flex-md-row" style="gap: 5px">
        <v-btn
          color="chip"
          :block="$vuetify.breakpoint.mdAndDown"
          :x-large="!$vuetify.breakpoint.mdAndDown"
          depressed
          rounded
          @click="deleteExpense(expenseData)"
        >
          <v-icon size="18" class="me-2">
            {{ icons.mdiDelete }}
          </v-icon>
          <div class="text-body-2 text-capitalize">Sil</div>
        </v-btn>
        <v-spacer />
        <div class="d-flex  align-center" style="gap: 10px">
          <v-btn
            color="error"
            :x-large="!$vuetify.breakpoint.mdAndDown"
            depressed
            rounded
            @click="rejectExpense(expenseData)"
          >
            <v-icon left>{{ icons.mdiCloseCircle }}</v-icon>
            Reddet
          </v-btn>

          <v-btn
            color="success"
            :x-large="!$vuetify.breakpoint.mdAndDown"
            depressed
            rounded
            @click="approveExpense(expenseData)"
          >
            <v-icon left>{{ icons.mdiCheckCircle }}</v-icon>
            Onayla
          </v-btn>
          <v-btn
            color="info"
            :x-large="!$vuetify.breakpoint.mdAndDown"
            depressed
            rounded
            @click="store.openEditDialog(expenseData)"
          >
            <v-icon left>{{ icons.mdiPencil }}</v-icon>
            Düzenle
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch, computed } from "vue-demi";

// Pinia
import { useCashReportStore } from "./store";

// Utils
import { useScroll, useResizeObserver } from "@vueuse/core";
import { useToast } from "vue-toastification/composition";
import Swal from "sweetalert2";

// Icons
import {
  mdiAbacus,
  mdiCloseCircle,
  mdiImageOffOutline,
  mdiDelete,
  mdiCheckCircle,
  mdiPencil,
} from "@mdi/js";

export default {
  setup() {
    const toast = useToast();
    const store = useCashReportStore();
    const userData = JSON.parse(localStorage.getItem("userData"));

    // Kaydırma çubuğu
    const scrollableEl = ref(null);
    const { arrivedState } = useScroll(scrollableEl);
    const isScroll = ref(false);

    // Ekran boyutu algılama
    useResizeObserver(scrollableEl, (entries) => {
      isScroll.value = scrollableEl.value?.scrollHeight === scrollableEl?.value.offsetHeight;
    });

    // Resim önizleme için state
    const imagePreviewDialog = ref(false);
    const selectedImage = ref(null);

    const closeForm = () => {
      store.closeViewDialog();
    };

    const openUrl = (url) => {
      window.open(url, "_blank");
    };

    const openImageDialog = (imageUrl) => {
      selectedImage.value = imageUrl;
      imagePreviewDialog.value = true;
    };

    // Masraf onaylama işlemi
    const approveExpense = (item) => {
      Swal.fire({
        title: "Masrafı Onaylama",
        text: "Bu masrafı onaylamak istediğinize emin misiniz?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Evet, Onayla",
        cancelButtonText: "İptal",
        confirmButtonColor: "#4caf50",
        cancelButtonColor: "#3085d6",
        focusConfirm: true,
        returnFocus: false,
        didOpen: () => {
          // Modal açıldığında fokus onay butonuna geçsin
          const confirmButton = Swal.getConfirmButton();
          if (confirmButton) confirmButton.focus();
        },
        // Animasyon ayarları
        showClass: {
          popup: "swal2-show-zoom-in",
          backdrop: "swal2-backdrop-show",
        },
        hideClass: {
          popup: "swal2-hide-zoom-out",
          backdrop: "swal2-backdrop-hide",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          // TODO: Burada onaylama API çağrısı yapılacak
          // Örnek: store.approveExpense(item.id)

          Swal.fire({
            title: "Onaylandı!",
            text: "Masraf başarıyla onaylandı.",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
            didOpen: () => {
              // Fokus kontrolü
              document.activeElement.blur();
            },
            // Animasyon ayarları
            showClass: {
              popup: "swal2-show-zoom-in",
              backdrop: "swal2-backdrop-show",
            },
            hideClass: {
              popup: "swal2-hide-zoom-out",
              backdrop: "swal2-backdrop-hide",
            },
          });

          // Dialog'u kapat
          store.closeViewDialog();
        }
      });
    };

    // Masraf reddetme işlemi
    const rejectExpense = (item) => {
      // Reddetme sebepleri listesi
      const rejectReasons = [
        { id: "fatura_hatali", text: "Fatura bilgileri hatalı" },
        { id: "belge_eksik", text: "Belgeler eksik" },
        { id: "miktar_uyumsuz", text: "Tutar uyumsuzluğu" },
        { id: "yetkisiz_islem", text: "Yetkisiz işlem" },
        { id: "ozel", text: "Özel (Açıklama Girin)" },
      ];

      // HTML içeriği oluştur
      let htmlContent = `
        <div class="swal-reddet-form">
          <div class="form-group mb-3">
            <label for="reddet-sebep-select">Reddetme Sebebi</label>
            <select id="reddet-sebep-select" class="swal2-select form-control" style="width:100%">
              <option value="">Sebep Seçiniz</option>
              ${rejectReasons
                .map((reason) => `<option value="${reason.id}">${reason.text}</option>`)
                .join("")}
            </select>
          </div>
          <div id="ozel-sebep-container" class="form-group mt-3" style="display:none">
            <label for="ozel-sebep-textarea">Özel Sebep Açıklaması</label>
            <textarea id="ozel-sebep-textarea" class="swal2-textarea form-control" placeholder="Reddetme sebebini yazınız..." style="width:100%"></textarea>
          </div>
        </div>
      `;

      Swal.fire({
        title: "Masrafı Reddetme",
        text: "Bu masrafı reddetmek istediğinize emin misiniz?",
        icon: "warning",
        html: htmlContent,
        showCancelButton: true,
        confirmButtonText: "Evet, Reddet",
        cancelButtonText: "İptal",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        focusConfirm: false,
        returnFocus: false,
        allowOutsideClick: false,
        // Animasyon ayarları
        showClass: {
          popup: "swal2-show-zoom-in",
          backdrop: "swal2-backdrop-show",
        },
        hideClass: {
          popup: "swal2-hide-zoom-out",
          backdrop: "swal2-backdrop-hide",
        },
        didOpen: () => {
          // Select ve textarea elementlerini al
          const selectEl = document.getElementById("reddet-sebep-select");
          const textareaContainer = document.getElementById("ozel-sebep-container");
          const textareaEl = document.getElementById("ozel-sebep-textarea");

          // Select değiştiğinde özel sebep alanını göster/gizle
          selectEl.addEventListener("change", function (e) {
            if (e.target.value === "ozel") {
              textareaContainer.style.display = "block";
              // Özel sebep seçildiğinde textarea'ya odaklan
              setTimeout(() => textareaEl.focus(), 100);
            } else {
              textareaContainer.style.display = "none";
            }
          });
        },
        preConfirm: () => {
          // Form verilerini al
          const selectEl = document.getElementById("reddet-sebep-select");
          const textareaEl = document.getElementById("ozel-sebep-textarea");
          const selectedReason = selectEl.value;
          const customReason = textareaEl.value.trim();

          // Validasyon
          if (!selectedReason) {
            Swal.showValidationMessage("Lütfen bir reddetme sebebi seçin!");
            return false;
          }

          if (selectedReason === "ozel" && !customReason) {
            Swal.showValidationMessage("Özel sebep açıklaması girilmelidir!");
            return false;
          }

          // Seçilen sebebe göre metin oluştur
          if (selectedReason === "ozel") {
            return customReason;
          } else {
            // Seçilen sebebin metnini bul
            const reasonText = rejectReasons.find((r) => r.id === selectedReason)?.text || "";
            return reasonText;
          }
        },
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          // TODO: Burada reddetme API çağrısı yapılacak
          // Örnek: store.rejectExpense(item.id, result.value)

          Swal.fire({
            title: "Reddedildi!",
            text: `Masraf "${result.value}" sebebiyle reddedildi.`,
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
            // Animasyon ayarları
            showClass: {
              popup: "swal2-show-zoom-in",
              backdrop: "swal2-backdrop-show",
            },
            hideClass: {
              popup: "swal2-hide-zoom-out",
              backdrop: "swal2-backdrop-hide",
            },
          });

          // Dialog'u kapat
          store.closeViewDialog();
        }
      });
    };

    // Masraf silme işlemi
    const deleteExpense = (item) => {
      Swal.fire({
        title: "Masrafı Silme",
        text: "Bu masrafı silmek istediğinize emin misiniz? Bu işlem geri alınamaz!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Evet, Sil",
        cancelButtonText: "İptal",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        focusConfirm: true,
        returnFocus: false,
        // Animasyon ayarları
        showClass: {
          popup: "swal2-show-zoom-in",
          backdrop: "swal2-backdrop-show",
        },
        hideClass: {
          popup: "swal2-hide-zoom-out",
          backdrop: "swal2-backdrop-hide",
        },
        didOpen: () => {
          // Modal açıldığında fokus onay butonuna geçsin
          const confirmButton = Swal.getConfirmButton();
          if (confirmButton) confirmButton.focus();
        },
      }).then((result) => {
        if (result.isConfirmed) {
          // TODO: Burada silme API çağrısı yapılacak
          // Örnek: store.deleteExpense(item.id)

          Swal.fire({
            title: "Silindi!",
            text: "Masraf başarıyla silindi.",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
            // Animasyon ayarları
            showClass: {
              popup: "swal2-show-zoom-in",
              backdrop: "swal2-backdrop-show",
            },
            hideClass: {
              popup: "swal2-hide-zoom-out",
              backdrop: "swal2-backdrop-hide",
            },
            didOpen: () => {
              // Fokus kontrolü
              document.activeElement.blur();
            },
          });

          // Dialog'u kapat
          store.closeViewDialog();
        }
      });
    };

    const expenseData = computed(() => store.viewData);

    const headers = [
      {
        text: "Resim",
        align: "start",
        sortable: false,
        value: "image",
        width: "50px",
      },
      {
        text: "Masraf Türü",
        align: "start",
        sortable: false,
        value: "expense_type",
        width: "150px",
      },
      {
        text: "Tutar",
        align: "start",
        sortable: false,
        value: "amount",
        width: "150px",
      },
      {
        text: "Fiş Tarihi",
        align: "start",
        sortable: false,
        value: "receipt_date",
        width: "150px",
      },
      {
        text: "Fiş No",
        align: "start",
        sortable: false,
        value: "receipt_no",
        width: "150px",
      },

      {
        text: "Açıklama",
        align: "start",
        sortable: false,
        value: "ltext",
      },
    ];

    const items = computed(() => {
      if (!store.viewData) return [];

      return expenseData.value.expense_lines;
    });

    watch(
      () => store.viewDialog,
      (val) => {
        if (val) {
          isScroll.value = scrollableEl.value?.scrollHeight === scrollableEl.value?.offsetHeight;
        }
      }
    );

    return {
      store,
      userData,
      expenseData,
      headers,
      items,
      isScroll,
      arrivedState,
      scrollableEl,
      openUrl,
      closeForm,
      // Resim önizleme
      imagePreviewDialog,
      selectedImage,
      openImageDialog,
      // İşlem fonksiyonları
      approveExpense,
      rejectExpense,
      deleteExpense,
      icons: {
        mdiAbacus,
        mdiCloseCircle,
        mdiImageOffOutline,
        mdiDelete,
        mdiCheckCircle,
        mdiPencil,
      },
    };
  },
};
</script>

<style>
/* SweetAlert özel formları için stiller */
.swal-reddet-form {
  text-align: left;
  max-width: 100%;
}

.swal-reddet-form label {
  display: block;
  margin-bottom: 0.5em;
  font-weight: bold;
  color: #555;
}

.swal-reddet-form select,
.swal-reddet-form textarea {
  width: 100%;
  padding: 0.5em;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: 0 !important;
  font-size: 1em;
}

.swal-reddet-form select:focus,
.swal-reddet-form textarea:focus {
  outline: none;
  border-color: #0088ff;
  box-shadow: 0 0 0 2px rgba(0, 136, 255, 0.2);
}

.form-group {
  margin-bottom: 1em;
}

/* SweetAlert textarea yüksekliği */
#ozel-sebep-textarea {
  min-height: 100px;
}

/* Özel SweetAlert Animasyonları */
.swal2-show-zoom-in {
  animation: swal2-zoom-in 0.3s;
}

.swal2-hide-zoom-out {
  animation: swal2-zoom-out 0.2s;
}

.swal2-backdrop-show {
  animation: swal2-fade-in 0.3s;
}

.swal2-backdrop-hide {
  animation: swal2-fade-out 0.2s;
}

@keyframes swal2-zoom-in {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes swal2-zoom-out {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.9);
  }
}

@keyframes swal2-fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes swal2-fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
